"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFO = exports.CUSTOM = exports.ERROR = exports.WARNING = exports.SUCCESS = exports.BOTTOM_RIGHT = exports.BOTTOM_CENTER = exports.BOTTOM_LEFT = exports.TOP_RIGHT = exports.TOP_CENTER = exports.TOP_LEFT = exports.SNACK_CLASS_NAME = exports.CONTAINER_CLASS_NAME = void 0;
exports.CONTAINER_CLASS_NAME = 'ap-snack-container';
exports.SNACK_CLASS_NAME = 'ap-snack';
exports.TOP_LEFT = 'top-left';
exports.TOP_CENTER = 'top-center';
exports.TOP_RIGHT = 'top-right';
exports.BOTTOM_LEFT = 'bottom-left';
exports.BOTTOM_CENTER = 'bottom-center';
exports.BOTTOM_RIGHT = 'bottom-right';
exports.SUCCESS = 'success';
exports.WARNING = 'warning';
exports.ERROR = 'error';
exports.CUSTOM = 'custom';
exports.INFO = 'info';
//# sourceMappingURL=constants.js.map